<div class="note-items-container" id="note-container" [ngClass]="{ 'mb-5': commonDataService.user.isReadOnly }">
    <button
        type="button"
        class="btn btn-sm btn-transparent sort-btn"
        (click)="onClickSortNotes()"
        container="body"
        placement="bottom"
        tooltip="{{ 'Reverse sort direction' | translate }}">
        @if (isAscSort) {
            {{ 'Oldest first' | translate }}
        } @else {
            {{ 'Newest first' | translate }}
        }
        <i
            class="ms-1 fa-solid"
            [ngClass]="{
                'fa-arrow-down-wide-short': isAscSort,
                'fa-arrow-up-wide-short': !isAscSort,
            }"></i>
    </button>

    @if (isLoading) {
        <sb-loader></sb-loader>
    }

    @if (!notes.length && !isLoading) {
        <div class="panel-list-text" translate>There are no notes yet on this ticket</div>
    }

    @if (count < notes.length && !isShowAllNotes && isAscSort) {
        <div class="align-self-end text-center pointer mb-2">
            <a (click)="isShowAllNotes = true" translate>See full conversation</a>
        </div>
    }

    <div>
        @for (
            note of notes | reversePaging: notes.length : count : isShowAllNotes : isAscSort;
            track note;
            let idx = $index
        ) {
            <app-note-item
                class="sb-list-item"
                [note]="note"
                [index]="idx"
                (handleDelete)="processDeletedNote($event)"></app-note-item>
        }
    </div>

    @if (count < notes.length && !isShowAllNotes && !isAscSort) {
        <div class="align-self-end text-center pointer mb-2">
            <a (click)="isShowAllNotes = true" translate>See full conversation</a>
        </div>
    }
</div>
@if (!commonDataService.user.isReadOnly) {
    <app-new-note
        class="new-note print-hidden"
        [ticketId]="ticket.id"
        [noteId]="0"
        (noteAdd)="addNote(notes, $event, true)"
        [isFocusNeeded]="isFocusNeeded"></app-new-note>
}
